
































































































































































































import Vue from 'vue'
import _ from 'lodash'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import WarningDialog from '@/components/WarningDialog.vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import moment from 'moment'
import { hexToRgba } from '@/services/hex-to-rgba'
import { FETCH_FIBU_TOOLS, FETCH_TOOLS_METADATA, TOOLS_ACTION } from '@/store/action-types'
import { ToolsActionPayload } from '@/types/payload'
import * as securityService from '@/services/security-service'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string
  loading: boolean
  searchLoading: boolean
  refreshLoading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  showReleaseWarningDialog: boolean
  showExportWarningDialog: boolean
  showUndoWarningDialog: boolean

  addressNumber: string | null
  addressName: string | null
  mail: string | null
  projectNumber: string | null
  projectNumberFrom: string
  projectNumberTo: string
  belegNumberFrom: string
  belegNumberTo: string
  dateFrom: string
  dateFromFormatted: string | null
  dateTo: string
  dateToFormatted: string | null
  type: number | null
  typeList: any[]
  status: number | null
  statusList: any[]
  profitCenter: any | null
  profitCenterList: any[]
  buchungslauf: number | null
  buchungslaufList: any[]

  menu1: boolean
  menu2: boolean
  dateRules: any[]
  gridData: any[]
  selectedRowKeys: any[]
  selectedRowsData: any[]

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ToolsPage',

  components: {
    ProgressCircular,
    WarningDialog,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    code: String
  },

  data (): ComponentData {
    return {
      tableHeight: '300px',
      loading: false,
      searchLoading: false,
      refreshLoading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      showReleaseWarningDialog: false,
      showExportWarningDialog: false,
      showUndoWarningDialog: false,

      addressNumber: null,
      addressName: null,
      mail: null,
      projectNumber: null,
      projectNumberFrom: '',
      projectNumberTo: '',
      belegNumberFrom: '',
      belegNumberTo: '',
      dateFrom: '',
      dateFromFormatted: '',
      dateTo: '',
      dateToFormatted: '',
      type: null,
      typeList: [],
      status: null,
      statusList: [],
      profitCenter: null,
      profitCenterList:  [],
      buchungslauf: null,
      buchungslaufList:  [],

      menu1: false,
      menu2: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],
      gridData:[],
      selectedRowKeys: [],
      selectedRowsData: [],

      keyActions: []
    }
  },

  computed: {
    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    showReleaseIcon (): boolean {
      return securityService.isVisible(SecurityArea.Tools, SecurityComponent.ReleaseIcon)
    },

    showExportIcon (): boolean {
      return securityService.isVisible(SecurityArea.Tools, SecurityComponent.ExportIcon)
    },

    showUndoIcon (): boolean {
      return securityService.isVisible(SecurityArea.Tools, SecurityComponent.UndoIcon)
    },

    isReleaseDisabled (): boolean {
      return !(this.selectedRowsData && this.selectedRowsData.length > 0 && this.selectedRowsData[0].Status === 1 && this.status === 1) || this.loading || this.searchLoading || this.refreshLoading || securityService.isDisabled(SecurityArea.Tools, SecurityComponent.ReleaseIcon)
    },

    isExportDisabled (): boolean {
      return !(this.selectedRowsData && this.selectedRowsData.length > 0 && this.selectedRowsData[0].Status === 2 && this.status === 2) || this.loading || this.searchLoading || this.refreshLoading || securityService.isDisabled(SecurityArea.Tools, SecurityComponent.ExportIcon)
    },

    isUndoDisabled (): boolean {
      return !(this.selectedRowsData && this.selectedRowsData.length > 0 && this.selectedRowsData[0].Status === 3 && this.status === 3) || this.loading || this.searchLoading || this.refreshLoading || securityService.isDisabled(SecurityArea.Tools, SecurityComponent.UndoIcon)
    },
  },

  watch: {
    dateFromFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateFrom = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateFrom = ''
      }
    },

    dateToFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateTo = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateTo = ''
      }
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    getTypLabel(item: number): string {
      const foundType: any | undefined = this. typeList.find((i: any) => i.Wert === item)
      return foundType ? foundType.Bezeichnung : ''
    },

    getStatusLabel(item: number): string {
      const foundStatus: any | undefined = this. statusList.find((i: any) => i.Wert === item)
      return foundStatus ? foundStatus.Bezeichnung : ''
    },

    formatDateBuchungslauf(item: string): string {
      return moment(item).isValid() ? moment(item).format('DD.MM.YYYY HH:mm') : ''
    },

    formatDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''
    },

    onDateFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurDateFrom (): void {
      this.dateFromFormatted = moment(this.dateFrom).isValid() ?  moment(this.dateFrom).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onDateToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurDateTo (): void {
      this.dateToFormatted = moment(this.dateTo).isValid() ?  moment(this.dateTo).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onSearchButtonClick (isRefresh: boolean): void {
      //const form: any = this.$refs['form']
      //if(form.validate()) {
        this.fetchFIBUData(isRefresh)
      //}
    },

    onSelectionChanged (data: any) {
      this.selectedRowKeys = data.selectedRowKeys
      this.selectedRowsData = data.selectedRowsData
    },

    onRefreshClick (): void {
      this.onSearchButtonClick(true)
    },

    onReleaseClick (): void {
      this.showReleaseWarningDialog = true
    },

    onReleaseWarningDialogClose (): void {
      this.showReleaseWarningDialog = false
    },

    onReleaseWarningDialogSave (): void {
      this.runTools(this.selectedRowKeys, 'Freigeben')
    },

    onExportClick (): void {
      this.showExportWarningDialog = true
    },

    onExportWarningDialogClose (): void {
      this.showExportWarningDialog = false
    },

    onExportWarningDialogSave (): void {
      const payload: number[] = this.gridData.map((item: any) => item.FinanzbelegID)
      this.runTools(payload, 'Verbuchen')
    },

    onUndoClick (): void {
      this.showUndoWarningDialog = true
    },

    onUndoWarningDialogClose (): void {
      this.showUndoWarningDialog = false
    },

    onUndoWarningDialogSave (): void {
      const payload: ToolsActionPayload = {
        action: 'Storno',
        fibuBeleg: this.selectedRowKeys[0]
      }

      this.runUndo(payload)
    },

    async runReleaseExport (payload: ToolsActionPayload): Promise<void> {
      await this.$store.dispatch(TOOLS_ACTION, payload)
    },

    async runTools (list: number[], action: string): Promise<void> {
      let promisesList: Promise<void>[] = []

      list.forEach((item: number) => {
        const payload: ToolsActionPayload = {
          action: action,
          fibuBeleg: item
        }

        promisesList.push(this.runReleaseExport(payload))
      })

      try {
        this.showReleaseWarningDialog = false
        this.showExportWarningDialog = false
        this.showUndoWarningDialog = false
        this.loading = true
        await Promise.all(promisesList)
        this.loading = false
        this.messageSnackbar = action === 'Freigeben' ? this.$t('toolsPage.releaseSuccess') : this.$t('toolsPage.exportSuccess')
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
        this.fetchFIBUData(true)
      } catch {
        this.loading = false
        this.messageSnackbar = action === 'Freigeben' ? this.$t('toolsPage.releaseError'): this.$t('toolsPage.exportError')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally { }
    },

    async runUndo (payload: ToolsActionPayload): Promise<void> {
      try {
        this.showReleaseWarningDialog = false
        this.showExportWarningDialog = false
        this.showUndoWarningDialog = false
        this.loading = true
        const response: any = await this.$store.dispatch(TOOLS_ACTION, payload)
        this.loading = false
        if (!response.IsError) {
          this.messageSnackbar = this.$t('toolsPage.undoSuccess')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchFIBUData(true)
        } else {
          this.messageSnackbar = this.$t('toolsPage.undoError')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('toolsPage.undoError')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally { }
    },

    async fetchFIBUData (isRefresh: boolean): Promise<void> {
      const payload: any = {
        Typ: this.type ? this.type : 0,
        Status: this.status ? this.status : 0,
        NummerVon: this.belegNumberFrom ? this.belegNumberFrom : 'null',
        NummerBis: this.belegNumberTo ? this.belegNumberTo : 'null',
        DatumVon: this.dateFrom ? this.dateFrom : '1900-01-01',
        DatumBis: this.dateTo ? this.dateTo : '1900-01-01',
        ProjektNummerVon: this.projectNumberFrom ? this.projectNumberFrom : 'null',
        ProjektNummerBis: this.projectNumberTo ? this.projectNumberTo : 'null',
        ProfitcenterCode: this.profitCenter ? this.profitCenter.Code : '',
        BuchungslaufID: this.buchungslauf ? this.buchungslauf : 0,
        AdressNummer: this.addressNumber ? this.addressNumber : '',
        AdressName: this.addressName ? this.addressName : '',
      }

      try {
        this.searchLoading = isRefresh ? false : true
        this.refreshLoading = isRefresh ? true : false
        const response: any = await this.$store.dispatch(FETCH_FIBU_TOOLS, payload)
        this.searchLoading = false
        this.refreshLoading = false
        this.gridData = response
        if(this.status === 2) {
          const payload: number[] = this.gridData.map((item: any) => item.FinanzbelegID)
          //@ts-ignore
          setTimeout(() => {
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows(payload)
          }, 100)
        } else {
          //@ts-ignore
          this.$refs.dataGrid.instance.selectRows([])
        }
      } catch {
        this.searchLoading = false
        this.refreshLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchMetaData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_TOOLS_METADATA)
        this.loading = false
        if(!response.IsError && response.Data) {
          this.typeList = response.Data.Finanztypen ? response.Data.Finanztypen : []
          this.type = this.typeList[0] ? this.typeList[0].Wert : null
          this.statusList = response.Data.Status ? response.Data.Status : []
          this.status = this.statusList[0] ? this.statusList[0].Wert : null
          this.buchungslaufList = response.Data.Buchungslauf ? _.orderBy(response.Data.Buchungslauf, ['Datum'], ['desc']) : []
          this.profitCenterList = response.Data.Profitcenter ? response.Data.Profitcenter : []
          this.profitCenter = this.profitCenterList[0] ? this.profitCenterList[0] : null
          this.fetchFIBUData(false)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 136px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, null,  null)
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchMetaData()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
